import axios from 'axios';
import { getGuestToken } from '../utils/guest';

// 创建axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器 - 添加token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const guestToken = getGuestToken();
    if (guestToken) {
      config.headers['X-Guest-Token'] = guestToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 统一错误处理
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      // token过期，跳转登录
      if (status === 401 || status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }

      return Promise.reject(data || { message: '请求失败' });
    }

    return Promise.reject({ message: '网络错误，请稍后重试' });
  }
);

// 认证相关API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me')
};

// 文章相关API（ICP）
export const articleAPI = {
  getArticles: (params) => api.get('/articles', { params }),
  getArticleById: (id) => api.get(`/articles/${id}`),
  getCategories: () => api.get('/articles/categories')
};

// 商品相关API（EDI）
export const productAPI = {
  getProducts: (params) => api.get('/products', { params }),
  getProductById: (id) => api.get(`/products/${id}`),
  getCategories: () => api.get('/products/categories')
};

// 购物车API（EDI）
export const cartAPI = {
  getCart: () => api.get('/cart'),
  addToCart: (data) => api.post('/cart', data),
  updateCartItem: (id, data) => api.put(`/cart/${id}`, data),
  removeFromCart: (id) => api.delete(`/cart/${id}`),
  clearCart: () => api.delete('/cart')
};

// 订单API（EDI）
export const orderAPI = {
  createOrder: (data) => api.post('/orders', data),
  getOrders: (params) => api.get('/orders', { params }),
  getOrderById: (id) => api.get(`/orders/${id}`),
  cancelOrder: (id) => api.put(`/orders/${id}/cancel`)
};

// 地址API（EDI）
export const addressAPI = {
  getAddresses: () => api.get('/addresses'),
  addAddress: (data) => api.post('/addresses', data),
  updateAddress: (id, data) => api.put(`/addresses/${id}`, data),
  deleteAddress: (id) => api.delete(`/addresses/${id}`),
  setDefaultAddress: (id) => api.put(`/addresses/${id}/default`)
};

// 公司信息API
export const companyAPI = {
  getInfo: () => api.get('/company-info')
};

// 地区数据API
export const regionsAPI = {
  getRegions: () => api.get('/regions')
};

// 支付API
export const paymentsAPI = {
  // 文章支付
  createArticlePayment: (data) => api.post('/payments/article', data),
  getOrderStatus: (orderNo) => api.get(`/payments/order/${orderNo}`),
  checkArticleAccess: (articleId) => api.get(`/payments/check-access/${articleId}`),
  getPurchaseHistory: (params) => api.get('/payments/purchases', { params }),

  // 商品订单支付
  createOrderPayment: (data) => api.post('/payments/order', data),
  getOrderPaymentStatus: (orderNo) => api.get(`/payments/order-status/${orderNo}`)
};

export default api;
